export default __webpack_public_path__ + "static/media/loginbg.9f35eb74.jpg";